
export default {
  name: 'RealEstatePortal'
}
